<template>
  <header :class="{ 'bd-banner-navbar': isBannerEnabled}" class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
    <div v-if="logoIsClickable()">
      <router-link exact class="nav-link" to="/"><img src="~@/assets/images/logoWhite.png" alt="asTech" style="height: 36px" /></router-link>
    </div>
    <div v-else>
      <img src="~@/assets/images/logoWhite.png" alt="asTech" style="height: 36px" />
    </div>

    <div class="navbar-nav-scroll">
      <ul class="navbar-nav bd-navbar-nav flex-row">
        <li class="nav-item" v-for="n of nav" :key="n.name">
          <router-link exact class="nav-link" v-if="isAllowed(n.url)" :to="n.url" title="n.name">{{n.name}}</router-link>
        </li>
      </ul>
    </div>

    <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
      <li v-if="user.prn" class="nav-item">
        <span class="nav-link">
          <i class="fas fa-user pr-1"></i>
          {{ user.prn }}
        </span>
      </li>
      <li class="nav-item">
        <a id="logout" href="#" @click="logout" class="nav-link" title="logout">
          <i class="fas fa-sign-out-alt"></i>
          Logout
        </a>
      </li>
    </ul>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-top',
  data() {
    return {
      nav: [
        { url: '/review-requests', name: 'Review Requests' },
        { url: '/work-orders', name: 'Work Orders' },
        { url: '/work-order-submit', name: 'Submit Request' },
        { url: '/admin', name: 'Administration' }
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAllowed', 'userProfile', 'primaryRole']),
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    ...mapActions('workOrders', ['setFilterBy']),
    async logout() {
      try {
        if (
          this.primaryRole === 'Tech' ||
          this.primaryRole === 'MasterTech' ||
          this.primaryRole === 'ReviewTech'
        ) {
          await this.setFilterBy({
            filter: 0,
            role: this.primaryRole,
            userId: this.userProfile.id
          })
        }
      } catch (e) {
        console.error(e)
      }
      this.clearToken()
      window.location.assign('/')
    },
    logoIsClickable() {
      // allow access to home page for only these roles:
      // SuperAdmin, Admin, Leadership, Manager
      let role = this.$store.state.auth.primaryRole
      let navAllowed = false

      if (
        role === 'SuperAdmin' ||
        role === 'Admin' ||
        role === 'Leadership' ||
        role === 'Manager' ||
        role === 'ReviewTech'
      ) {
        navAllowed = true
      }
      return navAllowed
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/nav-top.vue